import { useState } from 'react'
import styles from '../AllStyle.module.scss'
const SubdivisionInfo = () => {
  const [change, setChange] = useState(false)

  return (
    <div>
      <div className={styles.Design}>
        <div className={styles.DesignHeader}>
          <div className={styles.header_left}>
            <h4 className={styles.header_left_info}>Подразделения</h4>
          </div>
          <div className={styles.headerRight}>
            <input type="text" className={styles.Design_info_change_inp} />
          </div>
        </div>

        <ul className={styles.Design_desc}>
          <li className={styles.Design_list}>
            <h3 className={styles.Design_title}>ОРПО</h3>
            <p className={styles.Design_info}>ОКС</p>
          </li>

          <li className={styles.Design_list}>
            <h3 className={styles.Design_title}>Отдел кадров студентов</h3>
            <p className={styles.Design_info}>ОКС</p>
          </li>
          <li className={styles.Design_list}>
            <h3 className={styles.Design_title}>Склад</h3>
            <p className={styles.Design_info}>Склад</p>
          </li>
        </ul>
      </div>
    </div>
  )
}

export default SubdivisionInfo
